module.exports = __webpack_public_path__ + "img/Direct Debit.11d4de51.png";